export const ADDRESSES_LOAD_SUCCESS = "ADDRESSES_LOAD_SUCCESS";
